import { api, getDataSimple } from "../helpers/apiHelper";
const API_USER = "/account";
const API_PASSWORD_RESET = "/account/password-reset";

/**
 * fetch account information
 * account information include a finance field
 */
export const fetchUser = (): any => {
  const url = API_USER;
  return getDataSimple(url);
};

/**
 * Send username to request password reset
 */
export const resetPassword = (username: string): any => {
  const url = API_PASSWORD_RESET;
  const data = {
    username: username,
  };
  return api
    .post(url, data)
    .then(resp => {
      return resp.data;
    })
    .catch(error => {
      throw error;
    });
};

/**
 * Send update password for user login
 */
export const submitNewPassword = (
  username: string,
  newPassword: string,
  passwordConfirmation: string,
  resetToken: string
): any => {
  const url = `${API_PASSWORD_RESET}/${resetToken}`;
  const data = {
    username: username,
    newPassword: newPassword,
    passwordConfirmation: passwordConfirmation,
  };
  return api
    .post(url, data)
    .then(resp => {
      return resp.data;
    })
    .catch(error => {
      throw error;
    });
};

/**
 * Send username to request password reset
 */
export const updatePreferences = (
  view: string,
  payload: Record<string, any>
): any => {
  payload.preferences.uiViewMode = view;
  const url = API_USER;
  //
  let data = {
    accountId: payload["accountId"],
    userId: payload["userId"],
    preferences: {
      uiViewMode: view,
      oddsType: payload.preferences["oddsType"],
    },
  };
  return api
    .put(url, data)
    .then(resp => {
      return resp.data;
    })
    .catch(error => {
      throw error;
    });
};
export const updatePreference = (
  userId: string,
  accountId: string,
  payload: { [key: string]: boolean | string }
): any => {
  const url = API_USER;

  let data = {
    accountId: accountId,
    userId: userId,
    preferences: { ...payload },
  };

  return api
    .put(url, data)
    .then(resp => {
      return resp.data;
    })
    .catch(error => {
      throw error;
    });
};

/**
 * Update the users timezone
 */
export const updateTimezone = (
  timezone: string,
  payload: Record<string, any>
): any => {
  const url = API_USER;
  //
  let data = {
    accountId: payload["accountId"],
    userId: payload["userId"],
    preferences: {
      uiViewMode: payload.preferences.uiViewMode,
      oddsType: payload.preferences["oddsType"],
      timezone: timezone,
    },
  };
  return api
    .put(url, data)
    .then(resp => {
      return resp.data;
    })
    .catch(error => {
      throw error;
    });
};
